<div *ngIf="!loading" class="h-100 d-flex flex-column justify-content-between edit-group-popup">
  <div class="position-relative d-flex flex-column gap-3">
    <div class="w-100 d-flex justify-content-between align-items-start">
      <h2 mat-dialog-title class="custom-title">
        Edit the Group to share Spotlight experience
        <p *ngIf="data.isPreScheduleEvent">{{ cinejoyEvent?.name }}</p>
      </h2>
      <div class="bottom-sheet-header">
        <img
          style="
            width: 20px;
            cursor: pointer; /*position: absolute;right: 2px;right: -15px;top: -11px;*/
          "
          (click)="closePopup()"
          src="assets/icons/group-sharing/cancel-white.svg"
          alt="X"
        />
      </div>
    </div>
    <div class="d-flex flex-column gap-1">
      <label class="mb-0">Enter Group name</label>
      <input
        minlength="3"
        maxlength="30"
        placeholder="e.g. Creatics Rockerz"
        [(ngModel)]="groupName"
        class="form-control w-100"
        (change)="checkValidValue()"
      />
      <span class="err-msg" *ngIf="invalidGroupName"
        >Enter a valid Group name with minimum 3 characters upto 30 characters
        maximum.</span
      >
    </div>
    <div class="d-flex align-items-end gap-3 w-100">
      <div class="d-flex flex-grow-1 flex-column gap-1">
        <label class="mb-0">Add New Participant</label>
        <input
          [matAutocomplete]="auto"
          placeholder="John Doe"
          class="form-control"
          [formControl]="userInput"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          (optionSelected)="selectUser($event)"
        >
          <mat-option
            *ngFor="let option of filteredUsers | async"
            [value]="option"
          >
            {{ option.value }}
          </mat-option>
          <mat-option
            *ngIf="!filterHasLength && email && userInput.value"
          >
            <button
              type="button"
              mat-raised-button
              color="primary"
              class="ms-2"
              (click)="inviteUser($event)"
              style="background: #de1b36"
            >
              Invite User
            </button>
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
    <div class="participant-container">
      <table mat-table [dataSource]="tableData" class="mat-elevation-z0 w-100 edit-group-table">
        <caption class="d-none"></caption>

        <ng-container matColumnDef="name">
          <th
            style="width: 50%"
            class="text-start text-dark"
            mat-header-cell
            *matHeaderCellDef
          >
            Participant Name
          </th>
          <td style="width: 50%" mat-cell *matCellDef="let element">
            <span
              [matTooltip]="
                element.invited
                  ? 'This user will be invited to Creatics Platform.'
                  : ''
              "
              >{{ element.name }}</span
            >
          </td>
        </ng-container>

        <ng-container matColumnDef="rsvpStatus">
          <th
            style="width: 30%"
            class="text-center text-dark"
            mat-header-cell
            *matHeaderCellDef
          >
            RSVP Status
          </th>
          <td
            style="width: 30%"
            class="text-center"
            mat-cell
            *matCellDef="let element"
          >
            <span
              class="rsvp-status rsvp-{{ element.rsvpStatus }}"
              [matTooltip]="rsvpTooltips[element.rsvpStatus]"
              matTooltipPosition="above"
              >{{ rsvpStatusDisplayNames[element.rsvpStatus] }}</span
            >
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th
            style="width: 20%"
            class="text-center text-dark"
            mat-header-cell
            *matHeaderCellDef
          >
            Action
          </th>
          <td
            style="width: 20%"
            class="text-center"
            mat-cell
            *matCellDef="let element"
          >
            <button
              *ngIf="!element.invited && !element.newParticipant"
              mat-button
              class="mat-accent button-remove"
              label="Remove"
              matTooltip="Remove Existing Participant"
              matTooltipPosition="above"
              (click)="removeParticipant(element)"
            >
              Remove
            </button>
            <button
              *ngIf="element.invited || element.newParticipant"
              mat-button
              matTooltip="Remove New Participant"
              class="mat-accent button-remove"
              matTooltipPosition="above"
              (click)="removeParticipant(element)"
            >
            Remove
            </button>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          [ngClass]="{
            'new-participant': row.newParticipant,
            invited: row.invited
          }"
        ></tr>
      </table>
    </div>
  </div>
  <div class="w-100 d-flex align-items-center justify-content-end gap-3 pt-3 pb-2">
    <button
      mat-button
      class="text-white bg-transparent"
      label="Cancel"
      (click)="cancelEdit()"
    >
      Cancel
    </button>
    <button
      mat-button
      class="text-white bg-danger overflow-hidden"
      label="Cancel"
      (click)="deleteGroup()"
    >
      Delete Group
    </button>
    <button
      mat-flat-button
      class="mat-primary overflow-hidden"
      label="Remove"
      (click)="updateEvent()"
    >
      Save Changes
    </button>
  </div>
</div>
<div
  *ngIf="loading"
  class="w-100 h-100 d-flex align-items-center justify-content-center"
>
  <mat-spinner
    [diameter]="100"
    [strokeWidth]="5"
    class="mat-accent loading-color"
  ></mat-spinner>
</div>
